import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
} from '@angular/core';

@Directive({
    selector: '[spMultiHandlerRangeSlider]',
})
export class MultiHandlerRangeSliderDirective
    implements OnInit, OnDestroy, OnChanges
{
    @Input('defaultValues') defaultValues;
    @Input('relevantValues') relevantValues;
    @Input('oldSelectionValues') oldSelectionValues;
    @Input('newSelectionValues') newSelectionValues;

    @Output()
    valueChange: EventEmitter<any> = new EventEmitter(true);

    position_min = 0;
    position_max = 0;
    currentValue = 0;
    _defaultValues = { min: 0, max: 0 };
    _relevantValues = { min: 0, max: 0 };
    _oldSelectionValues = { min: 0, max: 0 };
    _newSelectionValues = { min: 0, max: 0 };
    slider: any;
    range_left: any;
    range_right: any;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2 //private control: NgControl
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        console.log('new values=======', this.newSelectionValues);
        this.ngOnDestroy();
        this.renderSlider();
    }
    ngOnDestroy(): void {
      try {

          this.renderer?.removeChild(
            this.renderer?.parentNode(this.elementRef.nativeElement),
            this.slider
        );
        this.renderer?.removeChild(
          this.renderer?.parentNode(this.elementRef.nativeElement),
          this.range_left
          );
        this.renderer?.removeChild(
          this.renderer?.parentNode(this.elementRef.nativeElement),
          this.range_right
          );

      } catch(e) {

      }
    }

    ngOnInit() {
      this.ngOnDestroy();
        this.renderSlider();
    }

    private renderSlider() {
        this.slider = this.renderer.createElement('div');
        this.renderer.addClass(this.slider, 'slider');

        const track = this.renderer.createElement('div');
        this.renderer.addClass(track, 'track');
        this.renderer.setAttribute(
            track,
            'default-min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            track,
            'default-max',
            this.defaultValues.max
        );

        const range = this.renderer.createElement('div');
        this.renderer.addClass(range, 'range');

        const relevant_range = this.renderer.createElement('div');
        this.renderer.addClass(relevant_range, 'relevant-range');
        this.renderer.setAttribute(
            relevant_range,
            'relevant-min',
            this.relevantValues.min
        );
        this.renderer.setAttribute(
            relevant_range,
            'relevant-max',
            this.relevantValues.max
        );
        var percent_relevant_left =
            ((this.relevantValues.min - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        relevant_range.style.left = percent_relevant_left + '%';

        var percent_relevant_right =
            ((this.defaultValues.max - this.relevantValues.max) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        relevant_range.style.right = percent_relevant_right + '%';

        const old_range = this.renderer.createElement('div');
        this.renderer.addClass(old_range, 'old-range');
        if (
            this.oldSelectionValues.min < this.relevantValues.min ||
            this.oldSelectionValues.max > this.relevantValues.max
        ) {
            this.renderer.setAttribute(
                old_range,
                'old-min',
                this.oldSelectionValues.min
            );
            this.renderer.setAttribute(
                old_range,
                'old-max',
                this.oldSelectionValues.max
            );
            var percent_old_left =
                ((this.oldSelectionValues.min - this.defaultValues.min) /
                    (this.defaultValues.max - this.defaultValues.min)) *
                100;
            old_range.style.left = percent_old_left + '%';

            var percent_old_right =
                ((this.defaultValues.max - this.oldSelectionValues.max) /
                    (this.defaultValues.max - this.defaultValues.min)) *
                100;
            old_range.style.right = percent_old_right + '%';
        }

        const thumb_left = this.renderer.createElement('div');
        this.renderer.addClass(thumb_left, 'thumb');
        this.renderer.addClass(thumb_left, 'left');
        this.renderer.setAttribute(
            thumb_left,
            'data-min',
            this.newSelectionValues.min
        );
        var percent_left =
            ((this.newSelectionValues.min - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        thumb_left.style.left = percent_left + '%';
        range.style.left = percent_left + '%';

        const thumb_right = this.renderer.createElement('div');
        this.renderer.addClass(thumb_right, 'thumb');
        this.renderer.addClass(thumb_right, 'right');
        this.renderer.setAttribute(
            thumb_right,
            'data-max',
            this.newSelectionValues.max
        );
        var percent_right =
            ((this.newSelectionValues.max - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        thumb_right.style.right = 100 - percent_right + '%';
        range.style.right = 100 - percent_right + '%';

        this.renderer.appendChild(this.slider, track);
        this.renderer.appendChild(this.slider, range);
        this.renderer.appendChild(this.slider, relevant_range);
        if (
            this.oldSelectionValues.min < this.relevantValues.min ||
            this.oldSelectionValues.max > this.relevantValues.max
        ) {
            this.renderer.appendChild(this.slider, old_range);
        }
        this.renderer.appendChild(this.slider, thumb_left);
        this.renderer.appendChild(this.slider, thumb_right);

        this.range_left = this.renderer.createElement('input');
        this.renderer.setAttribute(this.range_left, 'type', 'range');
        this.renderer.setAttribute(
            this.range_left,
            'min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            this.range_left,
            'max',
            this.defaultValues.max
        );
        this.renderer.setAttribute(this.range_left, 'step', '1');
        this.renderer.addClass(this.range_left, 'input-left');
        this.renderer.setAttribute(
            this.range_left,
            'value',
            this.newSelectionValues.min
        );

        this.range_right = this.renderer.createElement('input');
        this.renderer.setAttribute(this.range_right, 'type', 'range');
        this.renderer.setAttribute(
            this.range_right,
            'min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            this.range_right,
            'max',
            this.defaultValues.max
        );
        this.renderer.setAttribute(this.range_right, 'step', '1');
        this.renderer.addClass(this.range_right, 'input-right');
        this.renderer.setAttribute(
            this.range_right,
            'value',
            this.newSelectionValues.max
        );

        this.elementRef.nativeElement.style = 'display:none';
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.range_left
        );
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.range_right
        );
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.slider
        );

        this.renderer.listen(this.range_left, 'input', (event) => {
            old_range.style.opacity = 0;
            thumb_right.style.zIndex = 4;
            thumb_left.style.zIndex = 5;
            this.range_right.style.zIndex = 4;
            this.range_left.style.zIndex = 5;

            let min = +event.target.min;
            let max = +event.target.max;
            let position = +event.target.value;

            if (position > this.range_right.value) {
                var percent =
                    ((this.range_right.value - min) / (max - min)) * 100;
                thumb_left.style.left = percent + '%';
                range.style.left = percent + '%';
                this.range_left.value = this.range_right.value;
                this.valueChange.emit({
                    min: this.range_left.value,
                    max: this.range_right.value,
                });
                event.preventDefault();
                return false;
            }

            if (position < this.relevantValues.min) {
                var percent =
                    ((this.relevantValues.min - min) / (max - min)) * 100;
                thumb_left.style.left = percent + '%';
                range.style.left = percent + '%';
                this.range_left.value = this.relevantValues.min;
                this.valueChange.emit({
                    min: this.range_left.value,
                    max: this.range_right.value,
                });
                event.preventDefault();
                return false;
            }

            thumb_left.setAttribute('data-min', +event.target.value);
            var percent = ((position - min) / (max - min)) * 100;
            thumb_left.style.left = percent + '%';
            range.style.left = percent + '%';
            this.valueChange.emit({
                min: this.range_left.value,
                max: this.range_right.value,
            });
        });

        this.renderer.listen(this.range_right, 'input', (event) => {
            old_range.style.opacity = 0;
            thumb_left.style.zIndex = 4;
            thumb_right.style.zIndex = 5;
            this.range_left.style.zIndex = 4;
            this.range_right.style.zIndex = 5;

            let min = +event.target.min;
            let max = +event.target.max;
            let position = +event.target.value;

            if (position < this.range_left.value) {
                var percent =
                    ((this.range_left.value - min) / (max - min)) * 100;
                thumb_right.style.right = 100 - percent + '%';
                range.style.right = 100 - percent + '%';
                this.range_right.value = this.range_left.value;
                this.valueChange.emit({
                    min: this.range_left.value,
                    max: this.range_right.value,
                });

                event.preventDefault();
                return false;
            }

            if (position > this.relevantValues.max) {
                var percent =
                    ((this.relevantValues.max - min) / (max - min)) * 100;
                thumb_right.style.right = 100 - percent + '%';
                range.style.right = 100 - percent + '%';
                this.range_right.value = this.relevantValues.max;
                event.preventDefault();
                this.valueChange.emit({
                    min: this.range_left.value,
                    max: this.range_right.value,
                });

                return false;
            }

            thumb_right.setAttribute('data-max', +event.target.value);
            var percent = ((position - min) / (max - min)) * 100;
            thumb_right.style.right = 100 - percent + '%';
            range.style.right = 100 - percent + '%';
            this.valueChange.emit({
                min: this.range_left.value,
                max: this.range_right.value,
            });
        });
    }
}
